<form [formGroup]="formGroup" (ngSubmit)="createItem()" class="dialog-container">
  <div cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="dialog-header">
    <h4>{{ "template.item.saveTemplate" | translate }}</h4>
    <button type="button" (click)="dialogRef.close()" class="icon-close"></button>
  </div>
  <div class="container">
    <div class="section-container">
      <div class="flex-row">
        <div class="flex-1 card-cell">
          <sag-ui-input formControlName="title" [label]="'template.item.title' | translate" [required]="data.mode !== 'edit'" />
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-1 card-cell">
          <sag-ui-input formControlName="periodYear" type="number" [label]="'admin.template.item.period' | translate" [required]="data.mode !== 'edit'" />
        </div>
        <div class="flex-2"></div>
      </div>
    </div>
  </div>
  <div class="container container--sticky-bottom">
    <div class="section-container button-container">
      <sag-ui-button color="secondary" type="button" (click)="dialogRef.close()">
        {{ "default.buttons.cancel" | translate }}
      </sag-ui-button>
      <sag-ui-button color="primary" type="submit">
        {{ "default.buttons.save" | translate }}
      </sag-ui-button>
    </div>
  </div>
</form>
